(() => {
  'use strict';
  const init = () => {
    const modal = document.querySelector('[data-lds-badge-design-modal]');
    if (!modal || modal.dataset.initialized) return;
    modal.dataset.initialized = 'true';
    const dialog = modal.querySelector('[role="dialog"]');
    const mount = modal.querySelector('[data-lds-badge-design-form-mount]');
    const template = modal.querySelector('[data-lds-badge-design-form-template]');
    const success = modal.querySelector('[data-lds-badge-design-success]');
    const pilotRoot = document.querySelector('[data-lds-badge-text-preview]');
    const pilotSource = 'badge_custom_text_preview';
    const pilotProductTitle = 'License Plate Badge';
    const pilotProductType = 'License Plate Badge';
    const pilotTextSelector = '[name="contact[Your text or design idea]"]';
    const pilotColorSelector = '[name="contact[LED color]"]';
    let lastFocus = null;
    let source = '';
    let activePilot = false;
    let pilotPreviewSnapshot = null;

    const ensureForm = () => {
      let form = mount.querySelector('form');
      if (!form) {
        mount.appendChild(template.content.cloneNode(true));
        form = mount.querySelector('form');
      }
      return form;
    };
    const productContext = () => {
      const product = document.querySelector('[data-lds-badge-product]');
      if (!product) return { title: '', url: '', color: '' };
      const selected = product.querySelector('[data-lds-option-index="0"] [data-lds-option-value][aria-pressed="true"]');
      const color = selected?.dataset.ldsOptionValue || '';
      return {
        title: product.getAttribute('aria-label') || '',
        url: product.dataset.productUrl ? new URL(product.dataset.productUrl, location.origin).href : location.href,
        color: color === 'Flow' ? 'Flow RGB' : color,
      };
    };
    const put = (form, selector, value) => {
      const field = form.querySelector(selector);
      if (field) field.value = value;
    };
    const previewContext = () => {
      const hub = pilotRoot?.closest('[data-lds-accessories-hub]');
      if (hub) {
        const brand = hub.dataset.ldsHubBrand || 'Dodge';
        const selection = hub.querySelector('[data-hub-selected]');
        const vehicle = selection && !selection.hidden ? selection.querySelector('[data-hub-selected-label]')?.textContent.trim() || '' : '';
        return { brand, model: vehicle.startsWith(brand + ' ') ? vehicle.slice(brand.length + 1) : vehicle };
      }
      const collection = pilotRoot?.closest('[data-lds-plate-collection]');
      const catalog = collection?.querySelector('[data-lds-badge-catalog]') || collection;
      const ready = catalog?.dataset.badgeReady === 'true' && !catalog?.hasAttribute('aria-busy');
      const selected = ready ? collection?.querySelector('[data-badge-control="model"] input[data-badge-field="model"]:checked') : null;
      const hubBrand = collection?.querySelector('[data-badge-control="brand"] [data-badge-selected]');
      const brand = pilotRoot?.dataset.badgePreviewBrand || (ready && collection?.dataset.badgeHubActive === 'true' ? hubBrand?.textContent.trim() || '' : '');
      return { brand, model: brand ? selected?.value || '' : '' };
    };
    const setPilotOnlyFields = (form, pilot) => {
      let productType = form.querySelector('[name="contact[Product type]"]');
      if (pilot && !productType) {
        productType = document.createElement('input');
        productType.type = 'hidden';
        productType.name = 'contact[Product type]';
        productType.dataset.ldsBadgePilotProductType = 'true';
        form.appendChild(productType);
      }
      if (productType) {
        productType.value = pilot ? pilotProductType : '';
        productType.disabled = !pilot;
        productType.hidden = true;
      }

      const context = pilot ? previewContext() : {brand: '', model: ''};
      for (const key of ['Brand', 'Model']) {
        const name = `contact[${key}]`;
        let field = form.querySelector(`[name="${name}"]`);
        if (pilot && !field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = name;
          form.appendChild(field);
        }
        if (field) {
          field.value = context[key.toLowerCase()];
          field.disabled = !pilot || !field.value;
        }
      }

      let responsePromise = form.querySelector('[data-lds-badge-pilot-response-promise]');
      if (pilot && !responsePromise) {
        responsePromise = document.createElement('p');
        responsePromise.className = 'lds-custom-design-modal__note';
        responsePromise.dataset.ldsBadgePilotResponsePromise = 'true';
        responsePromise.textContent = 'We’ll email your design within 24 hours.';
        const actions = form.querySelector('.lds-badge-design-modal__actions');
        if (actions) actions.before(responsePromise);
        else form.appendChild(responsePromise);
      }
      if (responsePromise) responsePromise.hidden = !pilot;
    };
    const setContext = (form, prefillColor = false, pilot = false) => {
      const product = productContext();
      const contextProduct = pilot ? { ...product, title: pilotProductTitle, url: location.href } : product;
      put(form, '[data-lds-badge-design-source]', source);
      put(form, '[data-lds-badge-design-product-title]', contextProduct.title);
      put(form, '[data-lds-badge-design-product-url]', contextProduct.url);
      put(form, '[data-lds-badge-design-page-url]', location.href);
      put(form, '[data-lds-badge-design-subject]', `LED Badge Design Request — ${contextProduct.title || source}`);
      if (prefillColor && product.color) put(form, '[name="contact[LED color]"]', product.color);
      setPilotOnlyFields(form, pilot);
      return contextProduct;
    };
    const previewRadioValue = radio => {
      const declared = radio?.getAttribute('data-badge-preview-color');
      return declared && declared !== 'true' ? declared : radio?.value || radio?.dataset.badgePreviewColor || '';
    };
    const getPilotPreviewState = () => ({
      text: pilotRoot?.querySelector('[data-badge-preview-input]')?.value || '',
      color: previewRadioValue(pilotRoot?.querySelector('[data-badge-preview-color]:checked')),
    });
    const dispatchPreviewEvents = element => {
      element.dispatchEvent(new Event('input', { bubbles: true }));
      element.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const applyPilotPreviewToForm = (form, next, previous = null, initialize = false) => {
      if (initialize) put(form, '[name="contact[Design type]"]', 'Custom Text');
      if (initialize || !previous || next.text !== previous.text) put(form, pilotTextSelector, next.text);
      if (initialize || !previous || next.color !== previous.color) put(form, pilotColorSelector, next.color);
    };
    const syncPilotPreviewFromForm = (form, field) => {
      if (!activePilot || !pilotRoot) return;
      if (field === 'text') {
        const input = pilotRoot.querySelector('[data-badge-preview-input]');
        const text = form.querySelector(pilotTextSelector)?.value || '';
        if (input) {
          input.value = text;
          dispatchPreviewEvents(input);
        }
      }
      if (field === 'color') {
        const color = form.querySelector(pilotColorSelector)?.value || '';
        const radios = [...pilotRoot.querySelectorAll('[data-badge-preview-color]')];
        const selected = radios.find(radio => previewRadioValue(radio) === color);
        if (selected) {
          radios.forEach(radio => { radio.checked = radio === selected; });
          dispatchPreviewEvents(selected);
        }
      }
      pilotPreviewSnapshot = getPilotPreviewState();
    };
    const isPilotTrigger = trigger => Boolean(pilotRoot && pilotRoot.contains(trigger) && trigger.dataset.ldsBadgeDesignSource === pilotSource);
    const show = visible => {
      modal.hidden = !visible;
      document.body.classList.toggle('lds-custom-design-modal-open', visible);
      if (visible) dialog.focus();
    };
    const close = () => {
      show(false);
      lastFocus?.focus();
    };
    const open = trigger => {
      lastFocus = trigger;
      source = trigger.dataset.ldsBadgeDesignSource || 'badge_design';
      activePilot = isPilotTrigger(trigger);
      success.hidden = true;
      const form = ensureForm();
      if (activePilot) {
        const previewState = getPilotPreviewState();
        const hasPilotDraft = form.dataset.ldsBadgeDraftSource === pilotSource;
        if (!hasPilotDraft) {
          form.reset();
          form.dataset.ldsBadgeDraftSource = pilotSource;
          setContext(form, false, true);
          applyPilotPreviewToForm(form, previewState, null, true);
        } else {
          setContext(form, false, true);
          applyPilotPreviewToForm(form, previewState, pilotPreviewSnapshot);
        }
        pilotPreviewSnapshot = previewState;
      } else {
        form.reset();
        delete form.dataset.ldsBadgeDraftSource;
        pilotPreviewSnapshot = null;
        setContext(form, true, false);
      }
      show(true);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-lds-badge-design-trigger]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });
    modal.addEventListener('click', event => {
      if (event.target.closest('[data-lds-badge-design-close]')) close();
    });
    modal.addEventListener('input', event => {
      event.target.classList.remove('lds-custom-design-modal__invalid');
      if (activePilot && event.target.matches(pilotTextSelector)) syncPilotPreviewFromForm(event.target.form, 'text');
    });
    modal.addEventListener('change', event => {
      event.target.classList.remove('lds-custom-design-modal__invalid');
      if (activePilot && event.target.matches(pilotColorSelector)) syncPilotPreviewFromForm(event.target.form, 'color');
    });
    modal.addEventListener('submit', event => {
      const form = event.target;
      if (!form.matches('form')) return;
      let valid = true;
      form.querySelectorAll('[data-lds-badge-required]').forEach(field => {
        const value = field.value.trim();
        const okay = value !== '' && (field.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(value));
        field.classList.toggle('lds-custom-design-modal__invalid', !okay);
        if (!okay) valid = false;
      });
      if (form.querySelector('[data-lds-badge-design-honeypot]')?.value) valid = false;
      if (!valid) {
        event.preventDefault();
        form.querySelector('.lds-custom-design-modal__invalid')?.focus();
        return;
      }
      const product = setContext(form, false, activePilot);
      const value = name => form.querySelector(`[name="contact[${name}]"]`)?.value.trim() || '';
      put(form, '[data-lds-badge-design-body]', [
        'NEW LED BADGE DESIGN REQUEST',
        `Name: ${value('name')}`,
        `Email: ${value('email')}`,
        `Design type: ${value('Design type')}`,
        `LED color: ${value('LED color')}`,
        `Your text or design idea: ${value('Your text or design idea')}`,
        `Additional notes: ${value('Additional notes')}`,
        ...(activePilot ? [`Product type: ${value('Product type')}`, `Brand: ${value('Brand')}`, ...(value('Model') ? [`Model: ${value('Model')}`] : [])] : []),
        `Product: ${product.title}`,
        `Product URL: ${product.url}`,
        `Source: ${source}`,
        `Page URL: ${location.href}`,
      ].join('\n'));
    });
    document.addEventListener('keydown', event => {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button,input,select,textarea')].filter(el => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    if (new URLSearchParams(location.search).get('contact_posted') === 'true' && location.hash === '#LdsBadgeDesignForm') {
      mount.querySelector('form')?.remove();
      success.hidden = false;
      show(true);
    } else if (new URLSearchParams(location.search).get('badge_design') === '1') {
      const trigger = document.querySelector('[data-lds-badge-product] [data-lds-badge-design-trigger]');
      if (trigger) open(trigger);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
